import { render } from "./properties.vue?vue&type=template&id=952154e6&scoped=true&ts=true"
import script from "./properties.vue?vue&type=script&lang=ts"
export * from "./properties.vue?vue&type=script&lang=ts"

import "./properties.vue?vue&type=style&index=0&id=952154e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-952154e6"]])

export default __exports__